import * as querystring from 'querystring'
import _ from 'lodash'
import config from '../../config'
import doFetch from './doFetch';

export const uploadPortalImages = (id, files, longerWidth) => {
  const body = new FormData()
  const query = longerWidth ? `?${querystring.stringify({ longerWidth })}` : ''
  body.append('files', files)
  return doFetch(config.apiEndpoint + `/portal/${id}/images` + query, {
    header: {
      'content-type': 'multipart/form-data',
    },
    method: 'POST',
    body,
  }).then(result => {
    if (result.status === 200) return result.json()
    throw Error(result)
  })
}

export const uploadImage = (file, replacingImageId = '', originalImageId, longerWidth) => {
  const body = new FormData()
  const query = longerWidth ? `?${querystring.stringify({ longerWidth })}` : ''
  body.append('file', file)

  if(originalImageId){
    body.append('originalImageId', originalImageId)
  }
  
  return doFetch(
    config.apiEndpoint + `/image/${replacingImageId}` + query,
    {
      method: 'POST',
      body,
    },
  ).then(result => {
    if (result.status === 200) return result.json()
    throw new Error(result.statusText + " | " + result.status)
  })
}

export const uploadMainImage = (file, replacingImageId = '', originalImageId, longerWidth) => {
  const body = new FormData()
  const query = longerWidth ? `?${querystring.stringify({ longerWidth })}` : ''
  body.append('file', file)

  if(originalImageId){
    body.append('originalImageId', originalImageId)
  }
  
  return doFetch(
    config.apiEndpoint + `/main-image/${replacingImageId}` + query,
    {
      method: 'POST',
      body,
    },
  ).then(result => {
    if (result.status === 200) return result.json()
    throw new Error(result.statusText + " | " + result.status)
  })
}



export const uploadPortalImage = (id, file, replacingImageId = '', originalImageId, longerWidth) => {
  const body = new FormData()
  const query = longerWidth ? `?${querystring.stringify({ longerWidth })}` : ''
  body.append('file', file)

  if(originalImageId){
    body.append('originalImageId', originalImageId)
  }
  
  return doFetch(
    config.apiEndpoint + `/portal/${id}/image/${replacingImageId}` + query,
    {
      method: 'POST',
      body,
    },
  ).then(result => {
    if (result.status === 200) return result.json()
    throw new Error(result.statusText + " | " + result.status)
  })
}

export const removePortalImages = (id, imageIds) => Promise.all(
  _.map(imageIds, imageId => removePortalImage(id, imageId)),
)

export const removeImage = (imageId) => {
  return doFetch(`${config.apiEndpoint}/image/${imageId}`, {
    method: 'DELETE',
  })
    .then(result => {
      console.log("delete ", result)
      if (result.status === 200) return result.json()
      throw new Error(result.statusText + ' | ' + result.status)
    })
    .then(result => {
      console.log(result)
      if (result.status === 'ok') {
        return result
      } else {
        throw new Error(result.reason || '')
      }
    })
    .catch(error => {
      console.log(error)
      throw new Error('Remove Image error \n' + error.message || '')
    })
}

export const removePortalImage = (id, imageId) => {
  return doFetch(`${config.apiEndpoint}/portal/${id}/image/${imageId}`, {
    method: 'DELETE',
  })
    .then(result => {
      console.log("delete ", result)
      if (result.status === 200) return result.json()
      throw new Error(result.statusText + ' | ' + result.status)
    })
    .then(result => {
      console.log(result)
      if (result.status === 'ok') {
        return result
      } else {
        throw new Error(result.reason || '')
      }
    })
    .catch(error => {
      console.log(error)
      throw new Error('Remove Image error \n' + error.message || '')
    })
}

export const getImageFile = imageId =>
  doFetch(config.imageURLPrefix + "/" + imageId)
    .then(res => res.blob())
    .then(blob => new File([blob], imageId))



// WEBPACK FOOTER //
// ./src/modules/portal-remote/portalImageService.js